import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../theme/modern/tokens"
import {COARSE, touchTarget} from "../../../theme/modern/touchTargets"

export default makeStyles((theme: ModernTheme) => ({
    btn: {
        height: 32,
        padding: "0 16px",
        borderRadius: 8,
        border: `1px solid ${theme.modern.line}`,
        background: theme.modern.panel2,
        color: theme.modern.ink2,
        font: `600 12.5px ${theme.modern.sans}`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        whiteSpace: "nowrap",
        cursor: "pointer",

        "& svg": {width: 14, height: 14, flex: "none"},

        "&:hover": {borderColor: theme.modern.ink3, color: theme.modern.ink},
        "&:active": {filter: "brightness(.94)"},
        "&:disabled": {opacity: .55, cursor: "default", filter: "none"},

        [COARSE]: touchTarget({height: "auto", padding: "0 20px"}),
    },
    btn__primary: {
        background: theme.modern.accent,
        borderColor: theme.modern.accent,
        color: theme.modern.onAccent,

        "&:hover": {
            filter: "brightness(1.06)",
            borderColor: theme.modern.accent,
            color: theme.modern.onAccent,
        },
    },
    btn__ok: {
        background: theme.modern.ok,
        borderColor: theme.modern.ok,
        color: theme.modern.onAccent,

        "&:hover": {
            filter: "brightness(1.06)",
            borderColor: theme.modern.ok,
            color: theme.modern.onAccent,
        },
    },
  
    spinner: {
        width: 13,
        height: 13,
        flex: "none",
        borderRadius: "50%",
        border: "2px solid currentColor",
        borderTopColor: "transparent",
        animation: "$spin .7s linear infinite",
    },
    "@keyframes spin": {
        to: {transform: "rotate(360deg)"},
    },
}))
